<template lang="html">
  <div id="guarantees-page">

    <div class="container">
      <h2 class="common-title">{{ $t("shared.titles.warranties") }}</h2>

      <div class="row row-place">
        <div class="col-12 col-place" v-for="(warranty, prInx) in warranties" :key="prInx">
          <div class="row">
            <div class="col col-img">
              <img :src="warranty.imageUrl">
            </div>
            <div class="col col-text text-justify">
              <h5 class="mb-2">{{warranty.title}}</h5>
              <div v-html="warranty.description">

              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-place">
          <div class="row">
            <div class="col col-img">
              <img src="public/images/pages/guarantees/g-1.jpg">
            </div>
            <div class="col col-text text-justify">
              <h5 class="mb-2">CALIDAD DE PRODUCTOS</h5>
              <p>
                ESLOWINDOWS está decididamente comprometida con la calidad. La calidad con un fin: ofrecer productos fiables, una alta seguridad para el mercado de construccion.
              </p>
              <p class="mt-2">
                Los procesos de fabricación y instalacion han estado siempre regidos por estrictas normas Europeas de control. Todas las operaciones de desarrollo, producción, comercialización y asistencia post-venta están auditadas y certificadas. El seguimiento de esta reglamentación permite garantizar un servicio y unos productos de máxima calidad y fiabilidad, confirmado por la confianza que diariamente depositan varios clientes.
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 col-place">
          <div class="row">
            <div class="col col-img">
              <img src="public/images/pages/guarantees/g-2.jpg">
            </div>
            <div class="col col-text text-justify">
              <h5 class="mb-2">CARTA DE GARANTIA ESLOWINDOWS</h5>
              <p class="mb-2">
                El cliente siempre tiene la razón, dice un conocido proverbio, y con toda certeza, pues se trata de la persona que paga, y de lo que salga de su bolsillo depende el éxito de toda empresa. No sirve de nada tener un excelente producto a buen precio si no existen los compradores, y por eso hoy en día la atención al cliente es uno de los principales retos de nuestra empresa que desea mantenerse a flote en un ambiente cada vez más competitivo.
              </p>

              <p>
                <a target="_blank" download href="public/downloads/guarantees/cartagaranta.pdf">Carta de garantia - ESLOWINDOWS</a>
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 col-place">
          <div class="row">
            <div class="col col-img">
              <img src="public/images/pages/guarantees/g-3.jpg">
            </div>
            <div class="col col-text text-justify">
              <h5 class="mb-2">CARTA DE GARANTIA PROVEDOR ALUPLAST</h5>
              <p class="mb-2">
                Una empresa que pretende seguir siendo exitosa en el futuro y estar financieramente saneada no puede permitirse los defectos de calidad. La dura competencia en el mercado de la carpintería de PVC obliga actualmente a todas las empresas a aplicar ahorros, al mismo tiempo que aumentan las exigencias sobre la funcionalidad y calidad de los productos.
              </p>

              <p>
                <a target="_blank" href="public/downloads/guarantees/certificadoaluplastesloventanasgarantia001.jpg">Carta de garantia - Aluplast</a>
              </p>
            </div>
          </div>
        </div>

        <div class="col-12 col-place">
          <div class="row">
            <div class="col col-img">
              <img src="public/images/pages/guarantees/g-4.jpg">
            </div>
            <div class="col col-text text-justify">
              <h5 class="mb-2">CARTA DE GARANTIA PROVEDOR DE HERRAJES SIGENIA</h5>
              <p class="mb-2">
                Contamos con la representación de los mejores herrajes para las ventanas de la reconocida marca Alemana Sigenia. Los herrajes son los mas complejos en lo que a ventanería se refiere es por esta razón que no se puede colocar cualquier herraje en ventanas de PVC.
              </p>
              <p class="mb-2">
                Multidisciplinas a través de la marga Sigenia cuenta con herrajes para hojas de cualquier tamaño con un funcionamiento perfecto, tratamientos altamente resistentes a la corrosión y rotillería especializada en perfilies de PVC.
              </p>

              <p>
                <a target="_blank" href="public/downloads/guarantees/zertifikat_siau_20111102_spanisch.pdf">Certificado Sigenia</a> | <a target="_blank" href="public/downloads/guarantees/firmenpraesentation_siau_kfv_es.pdf">Sigenia Presentacion</a>
              </p>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      warranties: [],
    }
  },
  methods: {
    getWarranties: function(){
      axios.get(tools.url('/warrantiesFront')).then(
        ({data}) =>{
          this.warranties=data;
      });
    }
  },

  mounted() {
     this.getWarranties();
  }
  }
</script>
